import React from 'react';
import { Glyph } from '@visx/glyph';
import { Colorizers } from '@leverege/ui-attributes';
import GlyphSymbolizer from "../../models/glyph/GlyphSymbolizer.js";
import TextGlyphModel from "../../models/glyph/TextGlyphModel.js";
export default function DotGlyphRenderer(props) {
  const {
    model,
    color,
    x,
    y,
    datum,
    context
  } = props;
  const size = TextGlyphModel.getFontSize(model) || 14;
  const textModel = TextGlyphModel.getText(model);
  const strokeModel = TextGlyphModel.getStroke(model);
  const stroke = Colorizers.getColor(strokeModel, datum, {
    ...context,
    seriesColor: color
  }) || color;
  const text = GlyphSymbolizer.getSymbol(textModel, datum) || null;
  return /*#__PURE__*/React.createElement(Glyph, {
    left: x,
    top: y
  }, /*#__PURE__*/React.createElement("text", {
    dx: `-${size / 2}px`,
    dy: `${size / 2}px`,
    stroke: stroke,
    fontSize: size
  }, text));
}